export const uiPricingTable = {
    name: 'UI Pricing Table',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        tiers: {
            name: 'Tiers',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiPricingTier'] }],
                linkType: 'Entry'
            }
        },
        groups: {
            name: 'Groups',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiPricingGroup'] }],
                linkType: 'Entry'
            }
        },
        monthly: {
            name: 'Monthly',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        annually: {
            name: 'Annually',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        forever: {
            name: 'Forever',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        perUserPerMonth: {
            name: 'Per User Per Month',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        beforeUserField: {
            name: 'Before User Field',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        afterUserField: {
            name: 'After User Field',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        beforeUserMax: {
            name: 'Before User Max',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        afterUserMax: {
            name: 'After User Max',
            type: 'Symbol',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        background: {
            name: 'Background',
            type: 'Object',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiPricingTable.js.map